/**
 * 집계용 아이템 키.
 *
 * 사람들은 같은 것을 다르게 쓴다 — `REALFORCE`, `realforce`, `리얼포스 `.
 * 랭킹을 세려면 이것들이 한 칸으로 모여야 한다. 그렇다고 사용자가 쓴 글자를
 * 고치면 안 되므로, **원문은 그대로 두고 집계용 키를 따로 들고 간다.**
 *
 *   itemName: 'REALFORCE'   ← 화면에 나오는 것. 절대 건드리지 않는다
 *   itemKey:  'realforce'   ← 세는 데만 쓰는 것
 *
 * ⚠️ **이 함수는 한 번 정하면 바꾸지 않는다.** 규칙을 바꾸면 이미 저장된 키와
 * 새로 만드는 키가 어긋나, 같은 물건이 랭킹에서 두 줄로 갈라진다. 카테고리
 * id를 영구 고정하는 것과 같은 이유다.
 *
 * 그래서 검색 정규화(`normalizeForSearch`)와 **같은 동작이지만 따로 둔다.**
 * 검색은 품질을 위해 언제든 손볼 수 있어야 하는데(하이픈을 떼거나 자모를
 * 분해하거나), 그 변경이 집계 키까지 흔들면 과거 데이터가 조용히 깨진다.
 * 둘은 목적이 다르므로 각자 살아야 한다.
 *
 * 글자가 다른 표기(`리얼포스` ↔ `REALFORCE`)는 여기서 못 묶는다. 그건 상위
 * 몇 개만 사람이 별칭으로 묶는다 — 꼬리는 랭킹에 영향이 없다.
 */
export function itemKeyOf(itemName: string): string {
  return itemName.normalize('NFKC').toLowerCase().trim().replace(/\s+/g, ' ');
}
